module.exports = __webpack_public_path__ + "img/strong_core_values@2x.13ed1d35.png";